import { render } from "./rep021.vue?vue&type=template&id=2a5c20b6&scoped=true"
import script from "./rep021.vue?vue&type=script&lang=js"
export * from "./rep021.vue?vue&type=script&lang=js"

import "./rep021.vue?vue&type=style&index=0&id=2a5c20b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c20b6"]])

export default __exports__